import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import CoursPage from "@/pages/CoursPage";
import ProgressionPage from "@/pages/ProgressionPage";
import EntrainementPage from "@/pages/EntrainementPage";
import PfmpUniversPage from "@/pages/PfmpUniversPage";
import PortfolioPage from "@/pages/PortfolioPage";
import MemosPage from "@/pages/MemosPage";
import CareerPage from "@/pages/CareerPage";
import PfmpPortfolioPage from "@/pages/PfmpPortfolioPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<DashboardPage />} />
              <Route path="/cours" element={<CoursPage />} />
              <Route path="/progression" element={<ProgressionPage />} />
              <Route path="/pfmp-univers" element={<PfmpUniversPage />} />
              <Route path="/entrainement" element={<EntrainementPage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/memos" element={<MemosPage />} />
              <Route path="/recherche-stage" element={<CareerPage />} />
              <Route path="/pfmp-portfolio" element={<PfmpPortfolioPage />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminPage />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
